import type { Control, FieldPath, FieldPathValue, FieldValues } from 'react-hook-form';
import { useController } from 'react-hook-form';

import { Checkbox } from './Checkbox';
import type { Props as CheckboxProps } from './Checkbox';

interface CheckboxControllableProps<T extends FieldValues = FieldValues> extends Omit<
  CheckboxProps<T>,
  'control' | 'name'
> {
  name: FieldPath<T>;
  control: Control<T>;
  required?: boolean;
  defaultChecked?: boolean;
}

CheckboxControllable.S = Checkbox.S;

export function CheckboxControllable<T extends FieldValues = FieldValues>(
  props: CheckboxControllableProps<T>,
) {
  const { field } = useController<T, FieldPath<T>>({
    name: props.name,
    control: props.control,
    rules: { required: props.required, validate: props.validate },
    defaultValue: props.defaultChecked as FieldPathValue<T, FieldPath<T>>,
  });

  return (
    <Checkbox
      {...props}
      inputRef={field.ref}
      onBlur={field.onBlur}
      onChange={(value: unknown) => {
        field.onChange(value);
        // TODO
        // call props.onChange?
      }}
    />
  );
}
